<template>
  <a-spin :spinning="loading"></a-spin>
</template>

<script>
import api from "@/api";
import i18n from "@/assets/i18n/translate-message";

export default {
  name: "SsoLogin",
  data() {
    return {
      loading: false,
    };
  },
  /*
    目前支持这三种跳转
    localhost:8888/#/ssoLogin?routerLink=login&&token=111111111111
    cdfcd7d4-a46d-4649-8da4-735664ea7638/f3c09252-1435-4e09-a914-9fe698a2ebcf

    http://localhost:8888/#/ssoLogin?routerLink=workflows&&token=981dc293-8ccd-470f-9e36-99ba30af132&&username=%E8%A8%B1%E5%9D%87%E5%AF%A7&&lang=zh_CN&&tenantId=athenaPaasW

    localhost:8888/#/ssoLogin?routerLink=workflows&&token=981dc293-8ccd-470f-9e36-99ba30af1324&&
    username=許均寧&&lang=zh_CN&&tenantId=athenaPaasW

    http://localhost:8888/#/ssoLogin?routerLink=summary&&token=981dc293-8ccd-470f-9e36-99ba30af1324&&username=許均寧&&lang=zh_CN&&wId=3bf08bcf-fde9-4b2c-936a-c24b530f2866&&rId=2be7f49e-58df-439c-bc56-b9387759037a&&tenantId=thenaPaasW


    https://sc-console-paas.digiwincloud.com.cn/#/ssoLogin?routerLink=summary&&token=3eaa3644-41dc-4d03-aa94-b163265a3ab2&&username=test01&&lang=zh_CN&&wId=cdfcd7d4-a46d-4649-8da4-735664ea7638&&rId=f3c09252-1435-4e09-a914-9fe698a2ebcf&&tenantId=ccc

     */

  created() {
    this.getApiConifg();
  },
  methods: {
    async getApiConifg() {
      this.loading = true;
      const res = (await api.getAPIConfig()).data;
      localStorage.removeItem("config");
      localStorage.setItem("config", JSON.stringify(res));
      this.handleRouteParams();
      this.loading = false;
    },

    async handleRouteParams() {
      // 获取路由参数
      const { routerLink, token, username, lang, wId, rId, tenantId } =
        this.decodeObjectValues(this.$route.query);

      console.log("route params", this.$route.query);
      if (routerLink === "login") {
        // 首页
        console.log("to login:", this.$route.query);
        this.$router.push("/");
      } else {
        // 非首页
        localStorage.setItem("userName", username);
        localStorage.setItem("language", lang);
        this.$i18n.locale = lang;
        localStorage.setItem("token", token);
        this.$store.commit("auth/SET_ROUTER_KEY", tenantId);

        // 需要重新获取userInfo
        const res = await api.analyzeToken();
        if (res.status === 200 && res.data) {
          this.$store.commit("auth/SET_AUTH_INFO", {
            acceptLanguage: lang,
            userName: username,
            token,
            tenantId,
            ...res.data,
          });
          const resTenantList = await api.getTenantList();
          if (resTenantList.status === 200 && resTenantList.data) {
            this.$store.commit(
              "auth/SET_TENANT_LIST",
              resTenantList.data ?? []
            );
            if (routerLink === "workflows") {
              console.log("to workflows:", this.$route.query);
              this.$router.push("domains/athena/workflows");
            } else {
              // summary
              console.log("to summary:", this.$route.query);
              this.$router.push(
                `domains/athena/workflows/${wId}/${rId}/summary`
              );
            }
          } else {
            this.$message.error(i18n.t("dj-获取租户列表失败"));
            return;
          }
        } else {
          // 解析失败报错
          this.$message.error(i18n.t("dj-解析token失败"));
          return;
        }
      }
    },

    decodeObjectValues(obj) {
      const decodedObj = {};
      Object.keys(obj).forEach((key) => {
        const decodedValue = decodeURIComponent(obj[key]);
        decodedObj[key] = decodedValue;
      });

      return decodedObj;
    },
  },
};
</script>
